import { Map } from 'immutable';

import { getCategoryError } from '@/utils/validations/details';
import { getFirstValue } from '@/utils/taxonomy/ebay/properties';
import { getSize } from '@/utils/iterable/getSize';
import { reduce } from '@/utils/iterable/reduce';
import { get } from '@/utils/iterable/get';

import { EMPTY, VELA } from '@/constants';
import { ATTRIBUTE } from '@/constants/attributes';
import { STATUS } from '@/constants/listings';
import { VALUE } from '@/constants/product';
import { FORM } from '@/constants/forms';
import { DATA } from '@/data';

export const errors = {
  charachtersOverLimit({ limit, name }) {
    return `${name} should not exceed ${limit} characters`;
  },
  required({ name }) {
    return `${name} is required`;
  },
};

export function validateProductDetails({ marketplaceId, product }) {
  const status = product.get('status');
  const channel = product.get('channel');
  const category = product.getIn([FORM.DETAILS, ATTRIBUTE.ITEM_CATEGORY, VALUE]);
  const productDetails = product.getIn([FORM.DETAILS, ATTRIBUTE.PRODUCT_DETAILS], EMPTY.MAP);
  const taxonomyDetails = get([channel, marketplaceId, 'CATEGORIES', category, 'productDetails'])(DATA);

  if (getCategoryError({ category, channel, marketplaceId }) || getSize(taxonomyDetails) === 0) {
    return EMPTY.MAP;
  }

  let error = EMPTY.MAP;

  function reduceTaxonomyDetails(result, property, name) {
    if (property.required && getSize(productDetails.getIn([VALUE, name, 'value'])) === 0) {
      return result.set(name, errors.required({ name }));
    }

    return result;
  }

  function reduceProductDetails(result, detail, key) {
    const name = detail.get('name');
    const value = detail.get('value');
    const property = taxonomyDetails[name];

    if (!property || !getSize(value) === 0) return result;

    if (property.text) {
      const limit = property.max_length;

      if (limit && getSize(getFirstValue(value)) > limit) {
        return result.set(key, errors.charachtersOverLimit({ limit, name }));
      }
    }

    return result;
  }

  error = productDetails
    .get(VALUE)
    .reduce(
      reduceProductDetails,
      status === STATUS[VELA].TEMPLATE
        ? error
        : reduce(taxonomyDetails, error, reduceTaxonomyDetails)
    );

  return getSize(error)
    ? Map({ [ATTRIBUTE.PRODUCT_DETAILS]: error })
    : EMPTY.MAP;
}
